// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Raleway_2e06ba', '__Raleway_Fallback_2e06ba'","fontStyle":"normal"},"className":"__className_2e06ba","variable":"__variable_2e06ba"};